import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule,Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatError, MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

import { TProjectDetails } from '@core/interfaces/TProjectItem';

@Component({
    selector: 'app-edit-project-modal',
    templateUrl: './edit-project-modal.component.html',
    styleUrls: ['./edit-project-modal.component.scss'],
    standalone: true,
    imports: [ReactiveFormsModule, MatFormField, MatInput, MatError, MatButton]
})
export class EditProjectModalComponent {
  @Output() public saveCallback = new EventEmitter();

  public projectForm = this.fb.nonNullable.group({
    name: [this.data.name, [Validators.required]],
    description: [this.data.description]
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TProjectDetails,
    private dialogRef: MatDialogRef<EditProjectModalComponent>,
    private fb: FormBuilder,
  ) {
  }

  save(): void {
    this.saveCallback.emit(this.projectForm.value);
    this.dialogRef.close();
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
